import { BucketAwtENUM, gridSize, gridSizeMdLg4, gridSizeMdLg8, ModulosEnumChoice, ROUTER_PATHS, texto, useCheckPermissions, useUploadFile } from "@/shared"
import { useFetchMotivosRechazo, useGetSolicitudIngreso, useUpdateSolicitudesIngresos } from "@/shared/actions/erp"
import { CustomAutocomplete, CustomTextField, SingleButton, TabTextLabel } from "@/shared/components/ui"
import { Button, Grid, Paper, Tooltip, Typography } from "@mui/material"
import { useNavigate, useParams } from "react-router-dom"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useEffect, useState } from "react"

import { useForm } from "react-hook-form"
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store"
import { EstadosSolicitudIngresoEnum, MaterialTransferido } from "@/shared/interfaces"
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination"
import useTableDetalleProductoRevisionSolicitud from "../../shared/hooks/useTableDetalleProductoRevisionSolicitud"
import SmartTextArea from "@/shared/components/ui/SmartTextArea"
import CargarDocumentoSoluccionCosteada from "@/erp/venta-corporativa/solucion_costeada/shared/componente/cargar_documento_soluccion_costeada/CargarDocumentoSoluccionCosteada"
import { toast } from "react-toastify"
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs"
import { useUiStore } from "@/store/ui"
import { PermissionsEnum } from "@/auth/interfaces"
import { exportExcel, mapProductosToExcel, } from "../../function/revisionSolicitudExportarExcel"
import { RiFileExcel2Fill } from "react-icons/ri"



export default function RevisionSolicitudIngresoEditar() {
  useCheckPermissions(PermissionsEnum.api_change_solicitudingreso)

  const { id } = useParams()
  const navigate = useNavigate()
  const { data: dataSolicitudIngreso, isLoading } = useGetSolicitudIngreso(id!)
  //console.log('', dataSolicitudIngreso)
  //hook
  const { infoProducto } = useTableDetalleProductoRevisionSolicitud()
  const { handleUploadFile } = useUploadFile()
  //store
  const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const productos = useCargarSeriesProductos(s => s.productos)
  const pagination = useCargarSeriesProductos(s => s.pagination)
  const setPagination = useCargarSeriesProductos(s => s.setPagination)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);

  //state
  const [archivo, setArchivo] = useState<File | null>(null)
  const [isOpenModalRechazo, setIsOpenModalRechazo] = useState(false)
  ///fetch
  const { data: dataMotivoRechazo, isLoading: isLoadingMotivo } = useFetchMotivosRechazo({
    page_size: 600,
    modulo: ModulosEnumChoice.COMPRAS
  })
  ///mutation
  const updateSolicitudesIngreso = useUpdateSolicitudesIngresos({})
  //useEffect
  useEffect(() => {
    if (isLoading) return;
    if (!dataSolicitudIngreso?.data.productos?.length) return;
    const aux: MaterialTransferido[] = dataSolicitudIngreso?.data?.productos?.map((elemento) => ({
      ...elemento,
      codigo: elemento.codigo!,
      cantidad: elemento.cantidad!,
      id: elemento.id!,
      cantidad_aprobada: Number(elemento.cantidad)
    }))
    //console.log(aux)
    handleCopiarLista(aux!)

  }, [dataSolicitudIngreso])
  //
  type SaveFormData = {
    observaciones?: {
      observacionSolicitante: string;
      observacionRevision: string;
    }

    motivo_rechazo: string;
  }
  const form = useForm<SaveFormData>();
  const { formState: { errors } } = form;
  ///*****UPDATE*/
  const onSaveUpdate = async () => {


    //const cantidadAprovadaInValida = productos.find(item => item.cantidad_aprobada! <= 0 || isNaN(item.cantidad_aprobada!))
    /* if (cantidadAprovadaInValida) {
      toast.error(`El producto "${cantidadAprovadaInValida.codigo}" tiene una cantidad aprobada inválida, debe ser mayor a cero.`)
      return
    } */
    const isImage = archivo?.type.startsWith("image/")
    const bucketDestino = isImage
      ? BucketAwtENUM.IMAGE_REVISION_ORDEN
      : BucketAwtENUM.DOCUMENTO_REVISION_ORDEN_COMPRA
    const archivoRevision = (await handleUploadFile(archivo!, bucketDestino)).url;

    const urlsActual = dataSolicitudIngreso?.data.urls_imagenes || {}
    const observacioActual = dataSolicitudIngreso?.data.observaciones || {}
    const revisionSolicitudIngreso: any = {
      id: id,
      data: {
        estado_solicitud: EstadosSolicitudIngresoEnum.APROBADAS,
        productos: productos,
        observaciones: {
          ...observacioActual,
          observacionRevision: form.getValues().observaciones?.observacionRevision
        },
        urls_imagenes: {
          ...urlsActual,
          archivoRevision: archivoRevision
        }
      }

    }

    try {
      const result = await updateSolicitudesIngreso.mutateAsync(revisionSolicitudIngreso)
      if (result.code !== 200) return;
      navigate(ROUTER_PATHS.compras.solicitud_ingreso_revision_nav)
      clearSelectedItems()
      handldeGeneracionOrdenCompra()
    } catch (error) {
      console.error("Error en la mutación", error)
    }
  }
  ///*****update Rechazo********/
  const handleUpdateMotivo = async () => {

    if (form.getValues().motivo_rechazo === "")
      return toast.error("Seleccione un motivo, para proceder con la confirmación.")

    const isImage = archivo?.type.startsWith("image/")
    const bucketDestino = isImage
      ? BucketAwtENUM.IMAGE_REVISION_SOLIICTUD_COMPRA
      : BucketAwtENUM.DOCUMENTO_REVISION_SOLICITUD_COMPRA

    const archivoRevision = (await handleUploadFile(archivo!, bucketDestino)).url;
    const observacionActual = dataSolicitudIngreso?.data.observaciones || {}
    const urlsActual = dataSolicitudIngreso?.data.urls_imagenes || {}
    const solicitudCompraRechazo = {
      id: id,
      data: {
        estado_solicitud: EstadosSolicitudIngresoEnum.RECHAZADO,
        motivo_rechazo: form.getValues().motivo_rechazo,
        observaciones: {
          ...observacionActual,
          observacionRevision: form.getValues().observaciones?.observacionRevision
        },
        urls_imagenes: {
          ...urlsActual,
          archivoRevision: archivoRevision
        }
      }
    } as any
    //console.log('rechazo', solicitudCompraRechazo)
    setConfirmDialog({
      isOpen: true,
      subtitle: "¿Está seguro de que deseas Rechazar la solicitud de compra?. Esta acción no se puede deshacer.",
      title: "¡ Confirmar !",
      onClose() {
        setConfirmDialogIsOpen(false)
      },
      onConfirm: async () => {
        try {
          setIsOpenModalRechazo(false)
          setConfirmDialogIsOpen(false)
          const resp = await updateSolicitudesIngreso.mutateAsync(solicitudCompraRechazo)
          if (resp.code !== 200) return;
          //if (![200, 202].includes(resp.code)) return;
          navigate(ROUTER_PATHS.compras.solicitud_ingreso_revision_nav)
          clearSelectedItems()
        } catch (error) {
          console.log("Error al mutatar", error)
        }
      },
    })

  }
  //*****Modal de generación de orden compra******/
  const handldeGeneracionOrdenCompra = () => {
    setConfirmDialog({
      isOpen: true,
      title: "¡Aprobado con éxito!",
      subtitle: "La solicitud de compra se ha aprobado correctamente, el próximo paso es generar un Orden de pedido. ¿Te gustaría continuar?",
      onClose() {
        setConfirmDialogIsOpen(false)
      },
      onConfirm() {
        setConfirmDialogIsOpen(false)
        return navigate(`/compras/orden-compras/crear/${id}`)
      }
    }
    )
  }
  return (
    <>
      <Typography variant="h5">{'REVISIÓN DE SOLICITUD DE COMPRA'}</Typography>
      <Grid container spacing={2}>
        <Grid item {...gridSize} spacing={1} container justifyContent={'flex-end'}>
          <Grid item>
            <SingleButton
              label=" Atrás"
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={() => { navigate(`${ROUTER_PATHS.compras.solicitud_ingreso_revision_nav}`) }}
            />

          </Grid>
          <Grid item>
            <SingleButton
              label="Aprobar"
              variant="outlined"
              color={"success"}
              startIcon={<CheckCircleOutlineIcon />}
              onClick={() => { onSaveUpdate() }}
            />
          </Grid>
          <Grid item>
            <SingleButton
              label="Rechazar"
              variant="outlined"
              color={"error"}
              startIcon={<HighlightOffIcon />}
              onClick={() => setIsOpenModalRechazo(true)}
            />

          </Grid>
        </Grid>
        <SmartTextArea
          label="Observación Solicitante (Bodega)"
          name="observaciones.observacionSolicitante"
          control={form.control}
          texto={dataSolicitudIngreso?.data.observaciones?.observacionSolicitante || 'N/A'}
          title="Observación"
          size={gridSizeMdLg4}
          rows={1}
          maxPreviewWords={20}
        />
        <CustomTextField
          label={texto.observacion}
          placeholder="Escribir.."
          name="observaciones.observacionRevision"
          control={form.control}
          error={errors.observaciones?.observacionRevision}
          helperText={errors.observaciones?.observacionRevision?.message}
          required={false}
          //shrink={true}
          size={gridSizeMdLg8}
        />
        <Grid item xs={12}>
          <TabTextLabel text={'Respaldo de aprobación'} mt={0} pb={0} pl={0} pt={2} />
        </Grid>
        <Grid item {...gridSizeMdLg4}>
          <CargarDocumentoSoluccionCosteada
            idInput="documento-solicitud_compra"
            buttonText={'Respaldo de Aprobación'}
            selectedImage={archivo}
            setSelectedImage={setArchivo}
            accept=".pdf, .png, .jpg, .jpeg"
            tiposPermitidos={["application/pdf", "image/*"]}
            permiteImagen={true}
          />
        </Grid>

        <Grid item {...gridSize} mt={1}>
          <Paper className="productos">
            <Grid container spacing={1} justifyContent={'flex-end'}>
              <Tooltip title="Click">
                <Button
                  variant="outlined"
                  color="success"
                  onClick={() => exportExcel(mapProductosToExcel(productos), 'productos.xlsx')}
                  startIcon={
                    <RiFileExcel2Fill/>
                  }
                >
                  {'Exportar a Excel'}
                </Button>
              </Tooltip>
            </Grid>

            <SampleTablePagination
              columns={infoProducto}
              data={paginatedData}
              pagination={pagination}
              setPagination={setPagination}
              rowCount={productos.length}
            />

          </Paper>

        </Grid>
      </Grid>
      {isOpenModalRechazo && (
        <ScrollableDialogProps
          open={isOpenModalRechazo}
          title="Rechazar Solicitud Compra"
          onCloseIcon={() => { setIsOpenModalRechazo(false), form.setValue('motivo_rechazo', '') }}
          showRejectBtn={true} // activa el boton
          rejectVariantBtn={'outlined'}
          rejectBtnColor="error"
          onReject={handleUpdateMotivo}
          contentNode={
            <CustomAutocomplete
              label="Motivo"
              name="motivo_rechazo"
              options={dataMotivoRechazo?.data.data || []}
              isLoadingData={isLoadingMotivo}
              valueKey={"nombre"}
              actualValueKey={"codigo"}
              defaultValue={form.getValues().motivo_rechazo || ''}
              control={form.control}
              error={errors.motivo_rechazo}
              helperText={errors.motivo_rechazo?.message}
            />
          }
        />
      )}
    </>
  )
}